// extracted by mini-css-extract-plugin
export default {"color":"FieldColor_color__k8bE9","icon":"FieldColor_icon__4HJy7","small":"FieldColor_small__YoC4Q","large":"FieldColor_large__3IgzY"};